import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as api from '../../api/api'
import * as actions from '../../actions'
import { ListDivider } from 'rmwc/List';
import { Button, ButtonIcon } from 'rmwc/Button';
import { Link } from 'react-router-dom'
import {
  Dialog,
  DefaultDialogTemplate,
  DialogSurface,
  DialogHeader,
  DialogHeaderTitle,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
  DialogBackdrop
} from 'rmwc/Dialog';

import {TextField} from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';

import SerializeForm from 'form-serialize'

import {
  Card,
  CardPrimaryAction,
  CardMedia,
  CardAction,
  CardActions,
  CardActionButtons,
  CardActionIcons,
} from 'rmwc/Card';

import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Grid, GridCell } from 'rmwc/Grid';

import StatusMessage from '../../util/StatusMessage'
import SearchComponent from '../SearchComponent';

class MCRegisteredUsers extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: '',
      message: '',
      errorMsg: '',
      open: false,
      snackbarIsOpen: false,
      searchStatus: false,
      page: 1,
      data: {
        certification:'MC',
        testCycle:'5',
        registeredUsers:[],
        message:''
      },
      regDetails:{
        'level': '',
        'tracks': [],
        'topics': [],
        'test': 'tests'
      },
      searchData: {
        searchTerm: '',
        criteria: ''
      }
    }
    
    
  }


  componentDidMount() {
    this.fetchRegData()
  }


  handleDetails = (e, data) => {

    e.preventDefault();
    let regDetails = Object.assign({}, this.state.regDetails)
    this.setState({open: true})
    api.fetchAdminMCRegDetails(this.props.user.accessToken, data.certification_participation_id)
    .then((result) => {
      regDetails = result.data
      this.setState({open: true, regDetails: regDetails})
    }).catch((err) => {
          this.setState({ errorMsg: 'Unable to fetch details' })
    })

    
  }

  handleCycleChange = (e) => {
    let data = Object.assign({}, this.state.data)
    data.testCycle = e.target.value
    this.setState({data: data})
  }


  onOpenModal = () => {
    this.setState({ open: true });
  }

  onCloseModal = () => {
    this.setState({ open: false });
  }

  onInputChange = (evt) => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  }

  handleSearch = (searchTerm, criteria, pageNo) => {
    let certType = 'MC'
    let search = `admin/registered_users/search_by_criteria`
    let data = Object.assign({}, this.state.data)
    let searchData = Object.assign({}, this.state.searchData)
    searchData.searchTerm = searchTerm
    searchData.criteria = criteria
    this.setState({searchData: searchData, page: pageNo})

    let values = {
      'certType': certType,
      'searchTerm': searchTerm,
      'criteria': criteria,
      'pageNo': pageNo
    }
    api.adminRegisteredUsersSearch(this.props.user.accessToken, search, values)
    .then((result) => {
      if (result.status === 'success'){
        data.registeredUsers = result.data.mc_certifications
        this.setState({data:data, searchStatus: true})
      }
    })
  }

  fetchRegData = () => {
    let data = Object.assign({}, this.state.data)

    api.getRegisteredUsers(this.props.user.accessToken, data.certification, data.testCycle, this.state.page).then((result) => {
          const { status, errors} = result
          if (status === 'error') {
            this.setState({ errorMsg: 'Error in Fetching Detail' })  
          }
          if (status === 'success') {
            console.log(result)
            data.registeredUsers = result.data.mc_certifications
            this.setState({data:data})
          }
        })
        .catch((err) => {
          this.setState({ errorMsg: 'Error in Fetching Details' })
        })
  }

  handleFetch = (e) => {
    e.preventDefault()
    if (this.state.searchStatus === false) {
      this.fetchRegData()
    }
    else {
      this.handleSearch(this.state.searchData.searchTerm, this.state.searchData.criteria, parseInt(this.state.page))
    }
  }

  handleClear = (e) => {
    e.preventDefault()
    this.fetchRegData()
    this.setState({page: 1})
  }

  onPageTextChange = evt => {
    let page = Object.assign({}, this.state.page);
    page = evt.target.value;
    this.setState({page});
  }; 

   
  render() {
    
     const {registeredUsers} = this.state;
     let userListCompnent
     let handleDetails = this.handleDetails
     let openModal = this.openModal
     let handleSearch = this.handleSearch
     let handleClear = this.handleClear
     let handleFetch = this.handleFetch

     if(this.state.data.registeredUsers.length >0){
      console.log(this.state.data.registeredUsers)
      userListCompnent = 
        ( <tbody>
            {this.state.data.registeredUsers.map(regUser => (

              <tr>
                <td>{regUser.user_id}</td>
                <td>{regUser.user_name}</td>
                <td>{regUser.first_name}</td>
                <td>{regUser.last_name}</td>
                <td>{regUser.email}</td>
                <td>{regUser.phone}</td>
                <td>{regUser.level}</td>
                <td>{regUser.track}</td>
                <td>{regUser.mc_topics}</td>
                <td>{regUser.amount}</td>
                <td>{regUser.amount_paid}</td>
                <td>{regUser.status}</td>
                <td>{regUser.created_at}</td>
              </tr>
            ))}
          </tbody>  
        )

     }


     let Snackbarcomponent =(
          <Snackbar
            show={this.state.snackbarIsOpen}
            onHide={evt => this.setState({snackbarIsOpen: false})}
            message="Notification email sent to user with the access link"
      />
      )

    const { open } = this.state;
    let regDetails = this.state.regDetails;
    let trackComponent
    let topicComponent

    if(regDetails.tracks.length >0){
     trackComponent = (<div><h5> Tracks: </h5>
            {this.state.regDetails.tracks.map(regDetail => (
              <p> {regDetail} </p>
            ))}

            </div>)
    }

    if(regDetails.topics!== undefined && regDetails.topics.length >0){
     topicComponent = (<div><h5> Micro Credentails: </h5>
            {this.state.regDetails.topics.map(regDetail => (
              <p> {regDetail} </p>
            ))}

            </div>)
    } 

     let regDetailsModal=(
      <Dialog
        open={open}
         onClose={evt => this.setState({open: false})}
      >
        <DialogSurface>
        <DialogHeader>
          <DialogHeaderTitle>Registration Details</DialogHeaderTitle>
        </DialogHeader>
        <DialogBody>
          {regDetails.level}
          {trackComponent}
          {topicComponent}
        </DialogBody>
        <DialogFooter>
            <DialogFooterButton cancel>Close</DialogFooterButton>
            <StatusMessage error_msg = {this.state.errorMsg}/>
        </DialogFooter>
        </DialogSurface>
        <DialogBackdrop />  
      </Dialog>
    )

      return (
        <Grid>
          <GridCell span="12">
            <div><b>Micro credential Registered Users</b></div>
            <Grid>
              <GridCell span = "4">
                <TextField  className='text_input' label="Page Number" autoComplete="off" name="page" onChange={this.onPageTextChange} value={this.state.page}/>
                <Button  onClick={((e) => handleFetch(e))}>
                  Fetch
                </Button>
              </GridCell>
              <GridCell span="8">
              <SearchComponent onHandleSearch = {handleSearch}
                onHandleClear = {handleClear} />
              </GridCell>
            </Grid>

            <div>
              <table className="admin-table">
                <th>User Id</th>
                <th>User Name</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Certification Level</th>
                <th>Track</th>
                <th>MC Topics</th>
                <th>Amount</th>
                <th>Amount Paid</th>
                <th>Status</th>
                <th>Created_at</th>
                {userListCompnent}
              </table>
            </div>
            {regDetailsModal}
            
          </GridCell>
        </Grid>
      )
    
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MCRegisteredUsers);


// WEBPACK FOOTER //
// ./src/views/admin/MCRegisteredUsers.jsx